export default {
    cn: {
        apiLocale: 'zh-CN',
        base: '',
        // 
        sort: ['最新', '价格最高到底', '价格最低到高'],
    },
    en: {
        apiLocale: 'en',
        base: 'en',
        // 
        sort: ['Recently added', 'Price high-low', 'Price low-high'],
    }
}